import { Component, inject } from '@angular/core';
import { AppRoutes } from 'src/app/app-routes';
import { AuthService } from 'src/app/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public appRoutes = AppRoutes;

  private _auth: AuthService = inject(AuthService);

  public logout() {
    this._auth.logout();
  }
}
